import store from '../../vuex/store';
import moment from 'moment';
import axios from '../../v2/app/services/axiosService';
import fetchService from '../../v2/app/services/fetchService';

export default {
  activities() { // MLD-1742
    return [
      {id: 'delivered_at', name: 'Delivered'},
      {id: 'opened_at', name: 'Opened'},
      {id: 'clicked_at', name: 'Clicked'},
      {id: 'failed_at', name: 'Failed'},
      {id: 'complained_at', name: 'Complained'}, // MLD-2364
      //{id: 'bounced_at', name: 'Bounced'},
      //{id: 'dropped_at', name: 'Dropped'},
    ]
  },
  getStatusCodes() { // MLD-5635
    return [
      {
        id: 'Created',
        text: 'Created',
        color: 'blue lighten-3',
        icon: 'fa-hourglass-start',
      },
      {
        id: 'Accepted',
        text: 'Accepted',
        color: 'blue lighten-2',
        icon: 'fa-check-circle',
      },
      {
        id: 'Scheduled',
        text: 'Scheduled',
        color: 'blue lighten-1',
        darkMode: true,
        icon: 'fa-clock',
      },
      {
        id: 'Delivered',
        text: 'Delivered',
        color: 'info',
        darkMode: true,
        icon: 'fa-paper-plane',
      },
      {
        id: 'Opened',
        text: 'Opened',
        color: 'light-green lighten-1',
        darkMode: true,
        icon: 'fa-envelope-open',
      },
      { // MLD-7793
        id: 'Bot Clicked',
        text: 'Bot Clicked',
        color: 'light-green lighten-3',
        darkMode: true,
        icon: 'fa-user-robot',
      },
      {
        id: 'Clicked',
        text: 'Clicked',
        color: 'success',
        darkMode: true,
        icon: 'fa-hand-pointer',
      },
      {
        id: 'Failed',
        text: 'Failed',
        color: 'error',
        darkMode: true,
        icon: 'fa-exclamation-triangle',
      },
      {
        id: 'Canceled',
        text: 'Canceled',
        color: 'warning',
        darkMode: true,
        icon: 'fa-ban',
      },
      {
        id: 'Complained',
        text: 'Complained',
        color: 'warning',
        darkMode: true,
        icon: 'fa-exclamation-circle',
      },
    ]
  },
  dateFormat() {
    return 'YYYY-MM-DD'
  },
  initMessagesForm(perPage = 25) {
    return {
      activity: null,
      status: null,
      advanced: false,
      export: false, // MLD-1742
      group_id: '', // MLD-1997
      message_id: null,
      order_by: 'id',
      order_dir: 'desc',
      page: 1,
      per_page: perPage,
      recipient: null,
      sender_id: null,
      share_template_id: null, // MLD-5413
      subject: null,
      start_at: moment().startOf('day').subtract(1, 'month').format(this.dateFormat()),
      end_at: moment().endOf('day').format(this.dateFormat()),
      dates: [
        moment().startOf('day').subtract(1, 'month').format('YYYY-MM-DD'),
        moment().endOf('day').format('YYYY-MM-DD')
      ],
      //timePeriod: 'Month',
      is_sharing_email: '', // MLD-6818
      tags: [],
      is_test: '', // MLD-2066
      is_campaign: '', // MLD-5413
    };
  },
  initForm() {
    return {
      advanced: false,
      //domain: 'mg.mobilelocker.com',
      events: [], // MLD-827
      export: 0, // MLD-1742
      group_id: '', // MLD-1997
      message_id: '',
      order_by: 'event_at',
      order_dir: 'desc',
      page: 1,
      per_page: 25,
      recipient: '',
      sender_id: '',
      start_at: moment().subtract(1, 'month').format(this.dateFormat()),
      end_at: moment().endOf('day').format(this.dateFormat()),
      timePeriod: 'Month',
      tags: [],
      url: '',
    };
  },
  /**
   * @see https://documentation.mailgun.com/api-email-validation.html#example
   * @param email
   * @returns {*}
   */
  async validate(email) {
    const form = {
      email: email,
    };
    const response = await axios.post(`/api/mailgun/validate`, form);
    return response.data;
  },
  async getDomain(domain) {
    const response = await axios.get(`/api/mailgun/domains/${domain}`);
    return response.data;
  },
  async getWebhooksForDomain(domain) {
    const response = await axios.get(`/api/mailgun/domains/${domain}/webhooks`);
    return response.data;
  },
  async configureWebhooks(domain) {
    const response = await axios.post(`/api/mailgun/domains/${domain}/webhooks`);
    return response.data;
  },
  async getWebhookForDomain(domain, name) {
    const response = await axios.get(`/api/mailgun/domains/${domain}/webhooks/${name}`);
    return response.data;
  },
  async getDomains() {
    const response = await axios.get(`/api/mailgun/domains`);
    return response.data;
  },
  async getMessage(messageID) {
    const response = await axios.get(`/api/mailgun/messages/${messageID}`);
    return response.data;
  },
  async getMessageRaw(messageID) {
    const response = await axios.get(`/api/mailgun/messages/${messageID}/raw`);
    return response.data;
  },
  /**
   * MLD-5426 Fetch the messages in chunks.
   * @param form
   * @param chunkSize
   * @param concurrentRequests
   * @returns {Promise<Awaited<*[]>>}
   */
  async fetchMessages(form, chunkSize = 1_000, concurrentRequests = 3) {
    const url = `/api/mailgun/messages`;
    return await fetchService.fetchRecords(url, form, chunkSize, concurrentRequests);
  },
  async getMessages(form) {
    const response = await axios.get(`/api/mailgun/messages`, {params: form});
    return response.data;
  },
  async exportMessages(form, filename = 'messages.csv') {
    form.export = true;
    const response = await axios.post(`/api/mailgun/messages/search`, form);
    const data = response.data;
    // https://stackoverflow.com/questions/43432892/force-download-get-request-using-axios
    const blob = new Blob([data], {type: 'text/csv'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
    return data;
  },
  async getURLs() {
    const response = await axios.get(`/api/mailgun/urls`);
    return response.data;
  },
  async getWebhooks(form = null) {
    if (!form) {
      form = store.state.mailgun_form;
    }
    const response = await axios.get(`/api/mailgun/webhooks`, {params: form});
    return response.data;
  },
  async getWebhook(webhookID) {
    const response = await axios.get(`/api/mailgun/webhooks/${webhookID}`);
    return response.data;
  },
  events() {
    return [
      {id: 'bounced', name: 'Bounced'},
      {id: 'clicked', name: 'Clicked'},
      {id: 'complained', name: 'Complained'},
      {id: 'delivered', name: 'Delivered'},
      {id: 'dropped', name: 'Dropped'},
      {id: 'failed', name: 'Failed'},
      {id: 'opened', name: 'Opened'},
      {id: 'unsubscribed', name: 'Unsubscribed'},
    ];
  },
  async tags() {
    const response = await axios.get(`/api/mailgun/tags`);
    return response.data.map(t => {
      return {
        id: t,
        name: t,
      };
    });
  },
  async updateMessage(messageID, form) { // MLD-2066
    const response = await axios.put(`/api/mailgun/messages/${messageID}`, form);
    return response.data;
  },
  async getUniqueRecipients() { // MLD-2676
    const response = await axios.get(`/api/mailgun/recipients/emails`);
    return response.data;
  },
  async getEmailMetricsForCurrentTeam(form = {}) { // MLD-6080
    const options = {
      params: form,
    }
    const response = await axios.get(`/api/team/email-metrics`, options);
    return response.data;
  },
  async getEmailMetricsForTeam(teamID, form) { // MLD-6080
    const options = {
      params: form,
    }
    const response = await axios.get(`/api/teams/${teamID}/email-metrics`, options);
    return response.data;
  },
  async getEmailMetricsForCurrentUser(form) { // MLD-6080
    const options = {
      params: form,
    }
    const response = await axios.get(`/api/user/email-metrics`, options);
    return response.data;
  },
  async getEmailMetricsForUser(userID, form) { // MLD-6080
    const options = {
      params: form,
    }
    const response = await axios.get(`/api/users/${userID}/email-metrics`, options);
    return response.data;
  },
  async getDailyEmailMetricsForCurrentUser(column, form) { // MLD-6080
    const options = {
      params: {
        column,
        ...form,
      },
    }
    const response = await axios.get(`/api/user/emails/daily-metrics`, options);
    return response.data;
  },
  async getDailyEmailMetricsForUser(userID, column, form) { // MLD-6080
    const options = {
      params: {
        column,
        ...form,
      },
    }
    const response = await axios.get(`/api/users/${userID}/emails/daily-metrics`, options);
    return response.data;
  },
  /**
   *
   * @param {Integer} templateID
   * @param {String }column
   * @param {Object} form
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async getDailyEmailMetricsForShareTemplate(templateID, column, form) { // MLD-6072
    const params = {
      column,
      ...form
    }
    const response = await axios.get(`/api/share-templates/${templateID}/daily-metrics`, {params});
    return response.data;
  },
  async getDailyEmailMetricsForCampaign(campaignID, column, form) { // MLD-6072
    const params = {
      column,
      ...form
    }
    const response = await axios.get(`/api/mailcoach/campaigns/${campaignID}/daily-metrics`, {params});
    return response.data;
  },
  timePeriods() {
    return [
      {text: 'Today', start: {units: 0, period: 'day'}, end: {units: 0, period: 'day'}},
      {text: 'Yesterday', start: {units: -1, period: 'day'}, end: {units: -1, period: 'day'}},
      {text: 'Past 7 days', start: {units: -7, period: 'day'}, end: {units: 0, period: 'day'}},
      {text: 'Past 14 days', start: {units: -14, period: 'day'}, end: {units: 0, period: 'day'}},
      {text: 'Past 30 days', start: {units: -30, period: 'day'}, end: {units: 0, period: 'day'}},
      {text: 'Past 60 days', start: {units: -60, period: 'day'}, end: {units: 0, period: 'day'}},
      {text: 'This week', start: {units: 0, period: 'week'}, end: {units: 0, period: 'week'}},
      {text: 'This month', start: {units: 0, period: 'month'}, end: {units: 0, period: 'month'}},
      {text: 'This quarter', start: {units: 0, period: 'quarter'}, end: {units: 0, period: 'quarter'}},
      {text: 'This year', start: {units: 0, period: 'year'}, end: {units: 0, period: 'year'}},
      {text: 'Last month', start: {units: -1, period: 'month'}, end: {units: -1, period: 'month'}},
      {text: 'Last quarter', start: {units: -1, period: 'quarter'}, end: {units: -1, period: 'quarter'}},
      {text: 'Last year', start: {units: -1, period: 'year'}, end: {units: -1, period: 'year'}},
      {text: 'All time', start: {units: -10, period: 'year'}, end: {units: 0, period: 'year'}},
    ]
  },
}
